<template>
    <v-expansion-panel readonly>
        <v-snackbar
            v-model="saveEditedPayrollReport_snackbar"
            :timeout="3000"
            :color="saveEditedPayrollReport_snackbarColor"
            text
            top
        >
            {{ saveEditedPayrollReport_snackbarText }}

            <template v-slot:action="{ attrs }">
                <v-btn
                    color="grey darken-1"
                    icon
                    v-bind="attrs"
                    @click="saveEditedPayrollReport_snackbar = false"
                    small
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
        <v-expansion-panel-header hide-actions v-slot="{open}">
            <v-row>
                <v-col class="my-auto" cols="12" sm="6">
                    <v-btn 
                        small
                        rounded
                        color=""
                        @click="viewHistory(tabItems.item)"
                        class="px-4 me-2"
                        elevation="0"
                    >
                        
                    <v-tooltip color="warning" right v-if="tabItems.tba">
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon left>mdi-history</v-icon>
                            <v-badge
                                dot
                                color="warning"
                            >
                                <span
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                
                                    {{ tabItems.item }}: 
                                </span>
                            </v-badge>
                        </template>
                        <span>TBA</span>
                    </v-tooltip>
                        <template v-else>
                            <v-icon left>mdi-history</v-icon>
                            {{ tabItems.item }}:
                        </template>
                    </v-btn>
                    
                    <v-btn
                        v-if="open && tab == 0"
                        @click="setSelectedCompPanel(null)"
                        color="grey darken-3"
                        icon
                        x-small
                        elevation="0"
                        
                    >
                        <v-icon>
                            mdi-close
                        </v-icon>
                    </v-btn>
                    <v-btn
                        v-else-if="open && tab == 1"
                        @click="setSelectedDeductPanel(null)"
                        color="grey darken-3"
                        icon
                        x-small
                        elevation="0"
                        
                    >
                        <v-icon>
                            mdi-close
                        </v-icon>
                    </v-btn>
                    <v-btn
                        v-else
                        @click="edit(tabItems, index)"
                        color="grey darken-3"
                        icon
                        x-small
                        elevation="0"
                        :disabled="!tabItems.isEditable"
                        
                    >
                        <v-icon>
                            mdi-pencil
                        </v-icon>
                    </v-btn>
                    <!-- <v-fab-transition>
                        <v-btn
                            class="ms-4"
                            v-show="open"
                            icon
                            dark
                            x-small
                            color="green darken-2"
                            elevation="0"
                            @click="saveEditedPayrollReport(tabItems, index)"
                            :loading="isSavingEditLoading"
                            :disabled="isSavingEditLoading"
                        >
                            <v-icon>mdi-content-save</v-icon>
                        </v-btn>
                    </v-fab-transition> -->
                </v-col>
                <v-col class="my-auto" cols="12" sm="6">
                    <span class="float-right">$ {{ tabItems.itemValue || 0 }}</span>
                </v-col>
            </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
            <!-- <v-row>
                <v-col class="my-auto" cols="12" md="4" sm="6" v-if="tabItems.typesOfItem">
                    <v-select
                        v-model="typeOfItem"
                        :items="tabItems.typesOfItem"
                        :label="'Types of ' + tabItems.item"
                        required
                        dense
                    >
                        <template v-slot:item="{ item }">
                            <span class="me-2">{{ item }}</span>
                            <v-chip
                                color="orange orange-lighten-3"
                                text-color="black"
                                small
                                light
                            >
                                sample
                            </v-chip>
                        </template>
                        
                    </v-select>
                </v-col>
                <v-col class="my-auto" cols="12" md="4" sm="6" v-if="tabItems.typesOfItem">
                    <v-menu
                        v-model="dateMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="date"
                                label="Date"
                                prepend-icon="mdi-calendar"
                                readonly
                                :rules="[v => !!v || 'Date is required']"
                                required
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="date"
                            @input="dateMenu = false"
                        ></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col class="my-auto" cols="12" md="4" sm="6">
                    <v-text-field 
                        dense
                        prefix="$"
                        v-model="amount"
                        @keypress="preventNonNumericInput"
                        class="py-auto"
                        label="Amount"
                        required
                    >
                        {{ amount }}
                    </v-text-field>
                </v-col>
            </v-row> -->
            <updateRaises
                v-if="tabItems.item == 'Raise'"
                :tabItems="tabItems"
                @snackbarMsg="snackbarMsgfnc"
            ></updateRaises>
            <updateBonuses
                v-if="tabItems.item == 'Bonus'"
                :tabItems="tabItems"
                @snackbarMsg="snackbarMsgfnc"
            ></updateBonuses>
            <updateReimbursement 
                v-else-if="tabItems.item == 'Reimbursements'"
                :tabItems="tabItems"
                @snackbarMsg="snackbarMsgfnc"
            ></updateReimbursement>
            <updateHealthcare 
                v-else-if="tabItems.item == 'Health Care'"
                :tabItems="tabItems"
                @snackbarMsg="snackbarMsgfnc"
            ></updateHealthcare>
            <updateIncentives
                v-else-if="tabItems.item == 'Incentives'"
                :tabItems="tabItems"
                @snackbarMsg="snackbarMsgfnc"
            ></updateIncentives>
            <updateGarnishments
                v-else-if="tabItems.item == 'Garnishments'"
                :tabItems="tabItems"
                @snackbarMsg="snackbarMsgfnc"
            ></updateGarnishments>
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>

<script>
    // import axios from 'axios';
    // import moment from "moment";
    import {mapState, mapMutations} from "vuex";

    import updateBonuses from "./updateItemsComponents/updateBonuses.vue";
    import updateReimbursement from './updateItemsComponents/updateReimbursement.vue';
    import updateHealthcare from './updateItemsComponents/updateHealthcare.vue';
    import updateIncentives from './updateItemsComponents/updateIncentives.vue';
    import updateGarnishments from './updateItemsComponents/updateGarnishments.vue';
    import updateRaises from "./updateItemsComponents/updateRaises.vue";

    // const url = require("../../../client_config/config").url;
    export default {
        props: {
            isEdit: Boolean,
            tabItems: Object,
            tab: Number,
            index: Number,
            tabType: String,
        },

        components: {
            updateRaises,
            updateBonuses,
            updateReimbursement,
            updateHealthcare,
            updateIncentives,
            updateGarnishments,
        },

        data () {
            return {
                // isSavingEditLoading: false,
                dateMenu: false,

                typeOfItem: "",
                date: "",
                amount: null,

                saveEditedPayrollReport_snackbar: false,
                saveEditedPayrollReport_snackbarText: "",
                saveEditedPayrollReport_snackbarColor: "",

            }
        },

        created () {
            
        },

        computed: {
            ...mapState({
                selectedUserPayrollReport: state => state.payrollReportsHistories.selectedUserPayrollReport,
                isSavingEditLoading: state => state.payrollReportsHistories.isSavingEditLoading
            })
        },

        methods: {
            ...mapMutations({
                // setSelectedUserPayrollReport: "payrollReportsHistories/setSelectedUserPayrollReport",
                setContentTab: "payrollReportsHistories/setContentTab",
                setHistoryTab: "payrollReportsHistories/setHistoryTab",
                setSelectedCompPanel: "payrollReportsHistories/setSelectedCompPanel",
                setSelectedDeductPanel: "payrollReportsHistories/setSelectedDeductPanel",

                setTabItems: "payrollReportsHistories/setTabItems",
            }),

            preventNonNumericInput (e) {
                const keysAllowed= ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.'];
                const keyPressed= e.key;
                
                if (!keysAllowed.includes(keyPressed)) {
                    e.preventDefault()
                }
            },

            // saveEditedPayrollReport ( ) {
            //     this.isSavingEditLoading = true;

            //     var req_body = {
            //         tab: this.tab,
            //         item: tabItems.item,
            //         userId: this.selectedUserPayrollReport._id,
            //         date: moment(new Date()),
            //         amount: parseFloat(this.amount)
            //     }

            //     // Validates the edited item
            //     if (tabItems.typesOfItem) {
            //         if (this.typeOfItem == "") {
            //             this.saveEditedPayrollReport_snackbarText = "Type of " + tabItems.item + " is empty!";
            //             this.saveEditedPayrollReport_snackbarColor = "error";
            //             this.saveEditedPayrollReport_snackbar = true;

            //             // this.isSavingEditLoading = false;
            //         } else if (this.date == "") {
            //             this.saveEditedPayrollReport_snackbarText = tabItems.item + " date is empty!";
            //             this.saveEditedPayrollReport_snackbarColor = "error";
            //             this.saveEditedPayrollReport_snackbar = true;

            //             // this.isSavingEditLoading = false;
            //         } else if (this.amount == 0 || this.amount == null) {
            //             this.saveEditedPayrollReport_snackbarText = tabItems.item + " amount is 0!";
            //             this.saveEditedPayrollReport_snackbarColor = "error";
            //             this.saveEditedPayrollReport_snackbar = true;

            //             // this.isSavingEditLoading = false;
            //         } else {
            //             req_body.typeOfItem = this.typeOfItem
            //             // this.saveItemAPI(tabItems, req_body, index);
            //         }
            //     } else {
            //         if (this.amount == 0 || this.amount == null) {
            //             this.saveEditedPayrollReport_snackbarText = tabItems.item + " amount is 0!";
            //             this.saveEditedPayrollReport_snackbarColor = "error";
            //             this.saveEditedPayrollReport_snackbar = true;

            //             // this.isSavingEditLoading = false;
            //         } else {
            //             // this.saveItemAPI(tabItems, req_body, index);
            //         }
            //     }
            // },

            // saveItemAPI (tabItems, req_body, index) {
            //     axios.put(`${url}/customCompanyPayrolls/savePayrollReport`, req_body).then(() => {
            //         if (this.tab === 0) console.log("Saved edited compensation");
            //         else if (this.tab === 1) console.log("Saved edited deductions");

            //         tabItems.itemValue = parseFloat(req_body.amount);

            //         tabItems.isEdit = false;
            //         this.$emit('panel', index);

            //         this.saveEditedPayrollReport_snackbarText = tabItems.item + " saved.";
            //         this.saveEditedPayrollReport_snackbarColor = "success";
            //         this.saveEditedPayrollReport_snackbar = true;

            //         this.typeOfItem = "";
            //         this.date = "";
            //         this.amount = null;
            //     }).catch(error => {
            //         this.saveEditedPayrollReport_snackbarText = "Something went wrong! Please reload the page.";
            //         this.saveEditedPayrollReport_snackbarColor = "error";
            //         this.saveEditedPayrollReport_snackbar = true;
            //         console.log(error.response.data);
            //     }).finally(() => {
            //         this.isSavingEditLoading = false;
            //     });
            // },

            viewHistory (historyTab) {
                this.setContentTab('viewHistoryTab')
                this.setHistoryTab(historyTab)
            },

            edit (tabItems, index) {
                // this.$emit('panel', index)
                switch (this.tabType) {
                    case "comp":
                        this.setSelectedCompPanel(index);
                        break;
                    case "deduct":
                        this.setSelectedDeductPanel(index)
                        break
                    default:
                        console.log("tab type error!");
                        break;
                }
                
                this.setTabItems(tabItems);

                switch (tabItems.item) {
                    case "Raise":
                        tabItems.isEdit = !tabItems.isEdit
                        break;
                    case "Bonus":
                        tabItems.isEdit = !tabItems.isEdit
                        break;
                    case "Reimbursements": {
                        
                        // const routeData = this.$router.resolve({path: `/Reimbursements/${this.selectedUserPayrollReport._id}`,})
                        // window.open(routeData.href, '_blank');
                        tabItems.isEdit = !tabItems.isEdit
                        break;
                    }
                    case "Health Care":
                        tabItems.isEdit = !tabItems.isEdit
                        break;
                    case "Incentives":
                        tabItems.isEdit = !tabItems.isEdit
                        break;
                    case "Garnishments": {
                        // const routeData = this.$router.resolve({path: `/Garnishments/${this.selectedUserPayrollReport._id}`,})
                        // window.open(routeData.href, '_blank');
                        tabItems.isEdit = !tabItems.isEdit
                        break;
                    }
                    case "Writ":
                        tabItems.isEdit = !tabItems.isEdit
                        break;
                    case "Child Support":
                        tabItems.isEdit = !tabItems.isEdit
                        break;
                    case "Loan":
                        tabItems.isEdit = !tabItems.isEdit
                        break;  
                    default:
                        break;
                }
            },
            
            snackbarMsgfnc (val) {
                this.saveEditedPayrollReport_snackbarText = val.saveEditedPayrollReport_snackbarText;
                this.saveEditedPayrollReport_snackbarColor = val.saveEditedPayrollReport_snackbarColor;
                this.saveEditedPayrollReport_snackbar = val.saveEditedPayrollReport_snackbar;
            },
        }
    }
</script>